import React from 'react';

interface UiCopyBlockProps {
  text: string;
}

/**
 * Renders a plain-text content block for hospital-customisable copy
 * (questionnaire_top_text, questionnaire_bottom_text, success_top_text, success_bottom_text).
 *
 * - Returns null when `text` is empty / whitespace-only (no DOM node rendered).
 * - Preserves newlines via `whitespace: pre-wrap`. Note that justify leaves the
 *   line before each explicit newline un-stretched, which is what you want:
 *   every paragraph's last line stays ragged instead of being pulled apart.
 * - Justified ("stânga-dreapta") per ops, with hyphens-auto so a narrow phone
 *   column doesn't open rivers of whitespace between words.
 * - Styling deliberately mirrors the existing page body text so it blends in.
 */
const UiCopyBlock: React.FC<UiCopyBlockProps> = ({ text }) => {
  const trimmed = text.trim();
  if (!trimmed) return null;

  return (
    <div className="rounded-xl bg-blue-50 border border-blue-100 px-4 py-4 sm:px-5 sm:py-4">
      <p className="text-sm sm:text-base text-slate-700 leading-relaxed whitespace-pre-wrap hyphens-auto text-justify">
        {trimmed}
      </p>
    </div>
  );
};

export default UiCopyBlock;
